export enum TrackingHistStatusEnum {
  PENDENCIA_EMBARQUE = "pe", // Pendência Embarque
  SOLICITADO_COLETA = "sc", // Solicitado Coleta
  TRANSITO_INTERNACIONAL = "ti", // Trânsito Internacional
  AUTORIZACAO_FNE_COLOMBIA = "afnec", // Autorização FNE Colômbia
  AUTORIZACAO_EXPORT_MACEDONIA = "aem", // Autorização Export Macedônia
  INSPECAO_ANVISA = "ia", // Inspeção Anvisa
  SEFAZ = "sfz", // Sefaz
  TRANSITO_NACIONAL = "tn", // Trânsito Nacional
  TENTATIVA_ENTREGA = "te", // Tentativa de Entrega
  ENTREGA_EFETIVADA = "ee", // Entrega Efetivada
  PENDENCIA_VALIDACAO = "pv", // Pendência de Validação
  SOLUCIONADO = "s", // Solucionado
}

export type TrackingHistStatusTypes = `${TrackingHistStatusEnum}`;

export interface ITrackingHistDTO {
  id: number;
  tracking: number;
  track: number;
  status: TrackingHistStatusTypes;
  createdAt: Date;
}
